<template>
    <b-container>
        <div v-if="permissions.admin || permissions.article">
            <h4>Artikel:</h4>
            <hr class="mt-1 mb-3">
            <b-row>
                <b-col class="b-col">
                    <b-card
                        title="Artikel schreiben"
                    >
                        <b-card-text>Schreiben Sie einen neuen Artikel.</b-card-text>
                        <b-button href="/Artikel/Neu" variant="primary">Schreiben</b-button>
                    </b-card>
                </b-col>
                <b-col class="b-col">
                    <b-card title="Alle Artikel">
                        <b-card-text>Gucken Sie sich alle Artikel an.</b-card-text>
                        <b-button href="/Artikel" variant="primary">Ansehen</b-button>
                    </b-card>
                </b-col>
            </b-row>
        </div>

        <div v-if="permissions.admin || permissions.calendar">
            <h4 class="mt-5">Kalender:</h4>
            <hr class="mt-1 mb-3">
            <b-row>
                <b-col class="b-col">
                    <b-card
                        title="Termin erstellen"
                    >
                        <b-card-text>Tragen Sie einen neuen Termin ein.</b-card-text>
                        <b-button href="/Termine/Neu" variant="primary">Eintragen</b-button>
                    </b-card>
                </b-col>
                <b-col class="b-col">
                    <b-card title="Kategorie erstellen">
                        <b-card-text>Erstellen Sie eine neue Kategorie.</b-card-text>
                        <b-button href="/Kalender/Neu" variant="primary">Erstellen</b-button>
                    </b-card>
                </b-col>
                <b-col class="b-col">
                    <b-card title="Alle Termine">
                        <b-card-text>Sehen Sie sich alle Termine und Kategorien an.</b-card-text>
                        <b-button href="/Termine" variant="primary">Ansehen</b-button>
                    </b-card>
                </b-col>
            </b-row>
        </div>

        <div v-if="permissions.admin || permissions.warnings">
            <h4 class="mt-5">Hinweise:</h4>
            <hr class="mt-1 mb-3">
            <b-row>
                <b-col class="b-col">
                    <b-card
                        title="Hinweis erstellen"
                    >
                        <b-card-text>Erstellen Sie einen neuen Hinweis.</b-card-text>
                        <b-button href="/Hinweis/Neu" variant="primary">Schreiben</b-button>
                    </b-card>
                </b-col>
                <b-col class="b-col">

                    <b-card title="Alle Hinweise">
                        <b-card-text>Gucken Sie sich alle Hinweise an.</b-card-text>
                        <b-button href="/Hinweise" variant="primary">Ansehen</b-button>
                    </b-card>
                </b-col>
            </b-row>
        </div>

        <div v-if="permissions.admin || permissions.excuses">
            <h4 class="mt-5">Entschuldigungen:</h4>
            <hr class="mt-1 mb-3">
            <b-row>
                <b-col class="b-col">
                    <b-card
                        title="Entschuldigungen ansehen"
                    >
                        <b-card-text>Gucken Sie sich alle Entschuldigungen an.</b-card-text>
                        <b-button href="/Entschuldigungen" variant="primary">Ansehen</b-button>
                    </b-card>
                </b-col>
                <b-col class="b-col">
                    <b-card title="Entschuldigungen drucken">
                        <b-card-text>Drucken Sie sie heutigen Entschuldigungen.</b-card-text>
                        <b-button href="/Entschuldigungen/drucken" variant="primary">Drucken</b-button>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "Home",
    methods: {
        ...mapActions([
            'getPermissions'
        ])
    },
    computed: {
        ...mapGetters([
            'getStoredPermissions'
        ]),
        permissions() {
            return this.getStoredPermissions
        }
    },
    mounted() {
        this.getPermissions()
    }
}
</script>

<style scoped>
.b-col {
    margin-bottom: 10px;
}

</style>
